<template>
    <monitoring @search="search" @paginate="setPage" @sort="setSort" :setCurrentSubjectId="setCurrentSubjectId"
        :currentSubjectId="currentSubjectId" :loading="pending" :sort="sort" :records="paginatedRecords"
        :events="events" :total="totalRecords" :display="display" :show="showModal" :page="page" />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Monitoring from './Monitoring';

export default {
    name: 'monitoring-container',
    components: {
        Monitoring,
    },
    methods: {
        ...mapActions('monitoring', [
            'fetchMonitoring',
            'setCurrentSubjectId',
            'setPage',
            'setSort',
            'search',
            'resetState'
        ]),
        ...mapActions('modal', ['show']),
        showModal() {
            this.show('monitoring');
        },
    },
    computed: {
        ...mapState('monitoring', ['page', 'display', 'sort', 'events', 'currentSubjectId', 'pending']),
        ...mapGetters('monitoring', ['paginatedRecords', 'totalRecords']),
    },
    created() {
        this.fetchMonitoring()
            .then((res) => this.isFetching = false)
            .catch((res) => {
                this.isFetching = false;
            });
    },
    destroyed() {
        this.resetState();
    },
}
</script>



// WEBPACK FOOTER //
// MonitoringContainer.vue?6da7ec46